/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Faq_Add_AInputs */



/**
* | output |
* | --- |
* | "On the Customers page, click Add customer. Enter the customer's name, the plan and the email address of the person who will manage the organisation; storage ..." |
*
* @param {Partner_Faq_Add_AInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_faq_add_a = /** @type {((inputs?: Partner_Faq_Add_AInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Faq_Add_AInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Klicken Sie auf der Kundenseite auf „Kunde hinzufügen“. Geben Sie den Namen des Kunden, den Tarif und die E-Mail-Adresse der Person ein, die die Organisation verwalten wird; Speicher und der Compliance Copilot sind optional. Dieser Person senden wir eine Einladung per E-Mail, und Sie können den Link auch kopieren. Vertragskunden legen Sie über „Neuer Vertragskunde“ an; ihre Einladung wird verschickt, wenn die Organisation startet. Einen Link zur Selbstregistrierung gibt es noch nicht.")
	return /** @type {LocalizedString} */ ("On the Customers page, click Add customer. Enter the customer's name, the plan and the email address of the person who will manage the organisation; storage and the Compliance Copilot are optional. We email them an invitation, and you can also copy the link. Contract customers are added with New contract customer; their invitation is emailed when the organisation goes live. There is no self-signup link yet.")
});